import { chevronBackOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { Component, OnInit } from '@angular/core';
import { UserBookingSharesApiService } from 'src/app/api/services';
import { AppConfig } from '../../../../config/routes.config';
import { IonContent, IonRefresher, IonRefresherContent, IonNavLink, IonButton, IonIcon, IonCol, IonList, IonItem, IonRow } from "@ionic/angular/standalone";
import { DatePipe, NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

interface ShareAccessLog {
	message: string;
	date: string;
	fullName: string;
	type?: string;
}

@Component({
	selector: 'vl-shared-access-logs',
	templateUrl: './shared-access-logs.page.html',
	styleUrls: ['./shared-access-logs.page.scss'],
	imports: [IonRow, IonItem, IonList, IonCol, IonIcon, IonButton, IonNavLink, IonRefresherContent, IonRefresher, IonContent, NgFor, TranslatePipe, DatePipe]
})
export class SharedAccessLogsPage implements OnInit {
	shareId: number;
	bookingId;
	logs: Array<ShareAccessLog> = [];
	routes = AppConfig.routes;

	constructor(private shareApiService: UserBookingSharesApiService) {
    	addIcons({ chevronBackOutline });
	}

	ngOnInit() {
		this.getShareLogs();
	}

	getShareLogs(event = null) {
		this.shareApiService.getBookingShareLogs({
			id: this.shareId,
			page: 0,
			pageSize: 200
		}).subscribe(r => {
			console.log('logs', r);

			this.logs = r.elements.map(l => {
				return {
					message: l.message,
					date: l.createdDate,
					fullName: `${ l.user.firstName || '' } ${ l.user.lastName || '' }`,
					type: l.type
				}
			}).sort((a, b) => {
				return a.date > b.date ? 1 : -1;
			})
			if (event) {
				this.completeRefresh(event);
			}
		})
	}

	completeRefresh(e) {
		e.target.complete();
	}

	doRefresh(event) {
		this.logs = [];
		this.getShareLogs(event);
	}
}
